import React from 'react';
import {List, ListItem} from 'material-ui/List';
import {Route, Switch} from 'react-router-dom';
import Divider from 'material-ui/Divider';
import _ from 'lodash';
import Translate from 'translate';

import Emails from './emails/';
import Facebook from './facebook/';
import Settings from './settings/';
import Stucks from './stucks/';
import Twitter from './twitter/';
import Phone from './phone/';
import Status from './status/';

class Management extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      activeTab: 0,
      data: [],
    };

    this.socialNetworks = [
      { icon: 'facebook-f', name: 'Facebook', route: '/management/facebook' },
      { icon: 'twitter', name: 'Twitter', route: '/management/twitter' },
      { icon: 'envelope-o', name: <Translate id="email"/>, route: '/management/email' },
      { icon: 'commenting-o', name: <Translate id="sms"/>, route: '/management/phone' },
    ];
  }

  getActiveTabStyle( url ) {
    return this.props.location.pathname.indexOf( url ) !== -1 ? { backgroundColor: 'rgba(153,153,153,0.4)' } : {}
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="row mt-5">

          <div className="col-md-3">
            <section className="box box-default">
              <div className="box-header"><Translate id="socialNetworks"/></div>
              <div className="box-body py-0">
                <List>
                  <ListItem primaryText={<Translate id="status"/>}
                            leftIcon={<i className="fa fa-check text-center" style={{fontSize: 20}} />}
                            onClick={() => this.props.history.push( '/management/status' )}
                            style={this.getActiveTabStyle( '/management/status' )}
                  />
                  <Divider />
                </List>
              </div>

              <div className="box-header"><Translate id="stuckJobs"/></div>
              <div className="box-body py-0">
                <List>
                  <ListItem primaryText={<Translate id="stuckList"/>}
                            leftIcon={<i className="fa fa-clock-o text-center" style={{fontSize: 20}} />}
                            onClick={() => this.props.history.push( '/management/schedule' )}
                            style={this.getActiveTabStyle( '/management/schedule' )}
                  />
                  <Divider />
                </List>
              </div> 
              <div className="box-header"><Translate id="logs"/></div>
              <div className="box-body py-0">
                <List>
                  {_.map( this.socialNetworks, ( network, index ) =>
                    <ListItem key={index}
                              primaryText={network.name}
                              leftIcon={<i className={`fa text-center fa-${network.icon}`} style={{fontSize: 20}} />}
                              onClick={() => this.props.history.push( network.route )}
                              style={this.getActiveTabStyle( network.route )}
                    />
                  )}
                  <ListItem primaryText={<Translate id="system"/>}
                            leftIcon={<i className="fa fa-list-ul text-center" style={{fontSize: 20}} />}
                            onClick={() => this.props.history.push( '/management/system' )}
                            style={this.getActiveTabStyle( '/management/system' )}
                  />
                </List>
              </div>
            </section>
          </div>

          <div className="col-md-9">
            <Switch>
              <Route path={`${this.props.match.path}/status`} component={Status}/>
              <Route path={`${this.props.match.path}/facebook`} component={Facebook}/>
              <Route path={`${this.props.match.path}/twitter`} component={Twitter}/>
              <Route path={`${this.props.match.path}/phone`} component={Phone}/>
              <Route path={`${this.props.match.path}/email`} component={Emails}/>
              <Route path={`${this.props.match.path}/system`} component={Settings}/>
              <Route path={`${this.props.match.path}/schedule`} component={Stucks}/>
            </Switch>
          </div>
        </div>
      </div>
    )
  }
}

module.exports = Management;



// WEBPACK FOOTER //
// ./routes/app/routes/management/index.js